import React from 'react';
import classNames from 'classnames';
import { Input } from 'antd';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  input: {
    fontSize: 14,
    color: theme.colors.bodyColor,

    '&::placeholder': {
      color: theme.colors.disableColor,
    },
  },
}));

const CustomInput = React.forwardRef(({ className, ...restProps }, ref) => {
  const classes = useStyles();

  return <Input ref={ref} className={classNames(classes.input, className)} {...restProps} />;
});

export default CustomInput;
